import { mixColumn, mixLeftColumn, mixRightColumn } from './mix-css-classes';
/**
 * Resolves the padding and css class for a single column of a mix region.
 *
 * A single-column region spans the full width, so it must use symmetric inner
 * padding and the neutral column class — otherwise the first (idx === 0) and
 * last (idx === count - 1) branches both match and the last one wins, dropping
 * the left inner padding and producing broken left/right alignment.
 */
export const getMixColumnLayout = ({ idx, count, firstColumnPadding, secondColumnPadding, middleColumnPaddings, singleColumnPaddings, }) => {
    if (count === 1) {
        return { padding: singleColumnPaddings, cssClass: mixColumn };
    }
    if (idx === 0) {
        return { padding: firstColumnPadding, cssClass: mixLeftColumn };
    }
    if (idx === count - 1) {
        return { padding: secondColumnPadding, cssClass: mixRightColumn };
    }
    return { padding: middleColumnPaddings, cssClass: mixColumn };
};
//# sourceMappingURL=mix-column-layout.js.map